import React from 'react';
import ContentWrapper from '../Layout/ContentWrapper';
import {Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Badge} from 'reactstrap';
import Select from 'react-select';
import Swal from 'sweetalert2';
import moment from 'moment';
import 'moment-timezone';
import {getDrivers} from '../Drivers/DriverFunctions';
import {getHolidaysWorked, postHolidayWorked, deleteHolidayWorked} from './HolidaysWorkedFunctions';
import {getNBHolidays} from './NBHolidays';

moment.tz.setDefault("America/Halifax");

class HolidaysWorked extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            holidaysWorked: {},
            drivers: {},
            loading: true,
            year: moment().year(),
            showModal: false,
            processing: false,
            selectedHoliday: null,
            driver_ids: [],
            notes: '',
        };

        this.loadData = this.loadData.bind(this);
        this.updateField = this.updateField.bind(this);
        this.onDriversSelect = this.onDriversSelect.bind(this);
        this.submitEntry = this.submitEntry.bind(this);
        this.removeEntry = this.removeEntry.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.openModal = this.openModal.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {
        document.title = "Holidays Worked | Custom TMS";
        this.loadData();
    }

    loadData() {
        var self = this;
        self.setState({loading: true});
        getDrivers(function (drivers) {
            getHolidaysWorked(function (holidaysWorked) {
                self.setState({
                    drivers: drivers || {},
                    holidaysWorked: holidaysWorked || {},
                    loading: false,
                });
            });
        });
    }

    changeYear(direction) {
        this.setState({year: this.state.year + direction});
    }

    openModal(holiday) {
        this.setState({
            showModal: true,
            selectedHoliday: holiday,
            driver_ids: [],
            notes: '',
        });
    }

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }

    updateField(event) {
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value
        });
    }

    onDriversSelect(selected) {
        this.setState({
            driver_ids: selected ? selected.map(function (s) { return s.value; }) : []
        });
    }

    submitEntry(event) {
        event.preventDefault();
        if (!this.state.selectedHoliday || this.state.driver_ids.length < 1) {
            Swal("Error", "Please select at least one driver", "error");
            return;
        }
        this.setState({processing: true});
        var self = this;
        var data = {
            holiday_key: this.state.selectedHoliday.key,
            holiday_name: this.state.selectedHoliday.name,
            holiday_date: this.state.selectedHoliday.date.format('YYYY-MM-DD'),
            driver_ids: this.state.driver_ids,
            notes: this.state.notes,
        };
        postHolidayWorked(data, function (response) {
            self.setState({processing: false});
            if (typeof response.Message !== "undefined" && response.Message.indexOf("saved") !== -1) {
                Swal("Success!", response.Message, "success");
                self.setState({showModal: false, driver_ids: [], notes: ''});
                self.loadData();
            } else if (typeof response.Message !== "undefined") {
                Swal("Error", response.Message, "error");
            } else {
                Swal("Error", "Could not save entry", "error");
            }
        });
    }

    removeEntry(holiday_worked_id) {
        var self = this;
        Swal.fire({
            title: 'Are you sure?',
            text: "This will remove the driver from the holiday worked list.",
            showCancelButton: true,
            confirmButtonText: 'Yes, remove it',
            cancelButtonText: 'Cancel',
            type: 'warning'
        }).then(function (result) {
            if (result.value) {
                deleteHolidayWorked(holiday_worked_id, function (response) {
                    if (typeof response.Message !== "undefined" && response.Message.indexOf("removed") !== -1) {
                        self.loadData();
                    } else if (typeof response.Message !== "undefined") {
                        Swal("Error", response.Message, "error");
                    }
                });
            }
        });
    }

    driverName(driver_id) {
        if (typeof this.state.drivers[driver_id] !== "undefined") {
            var driver = this.state.drivers[driver_id];
            return driver.first_name + " " + driver.last_name;
        }
        return "Driver #" + driver_id;
    }

    render() {
        var self = this;
        var isDesignatedUser = parseInt(this.props.staff_id) === 1;
        var holidays = getNBHolidays(this.state.year);

        var driverOptions = Object.values(this.state.drivers).filter(function (d) {
            return d.status === 1 || d.status === 2;
        }).map(function (d) {
            return {value: d.driver_id, label: d.first_name + " " + d.last_name};
        }).sort(function (a, b) {
            return a.label.localeCompare(b.label);
        });

        var allEntries = Object.values(this.state.holidaysWorked);

        return (
            <ContentWrapper>
                <div className="content-heading">
                    <div>Holidays Worked</div>
                    <div className="ml-auto d-flex align-items-center">
                        <Button size="sm" color="secondary" className="mr-1" onClick={() => this.changeYear(-1)}>
                            <i className="fas fa-chevron-left"></i>
                        </Button>
                        <span className="mx-2 font-weight-bold">{this.state.year}</span>
                        <Button size="sm" color="secondary" onClick={() => this.changeYear(1)}>
                            <i className="fas fa-chevron-right"></i>
                        </Button>
                    </div>
                </div>

                <Row>
                    {holidays.map(function (holiday) {
                        var entries = allEntries.filter(function (e) {
                            return e.holiday_date === holiday.date.format('YYYY-MM-DD');
                        });
                        return (
                            <Col lg={6} key={holiday.key} className="mb-3">
                                <div className="card card-default h-100">
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <div>
                                            <div className="card-title mb-0">{holiday.name}</div>
                                            <small className="text-muted">{holiday.date.format('dddd, MMMM D, YYYY')}</small>
                                        </div>
                                        {isDesignatedUser && (
                                            <Button size="sm" color="primary" onClick={() => self.openModal(holiday)}>
                                                <i className="fas fa-plus"></i> Add
                                            </Button>
                                        )}
                                    </div>
                                    <div className="card-body">
                                        {entries.length === 0 && (
                                            <div className="text-muted">No drivers recorded as having worked</div>
                                        )}
                                        {entries.map(function (entry) {
                                            return (
                                                <Badge key={entry.holiday_worked_id} color="info" className="mr-2 mb-2 p-2" style={{fontSize: '13px'}}>
                                                    {entry.driver_name || self.driverName(entry.driver_id)}
                                                    {entry.notes ? " - " + entry.notes : ""}
                                                    {isDesignatedUser && (
                                                        <i className="fas fa-times ml-2"
                                                           style={{cursor: 'pointer'}}
                                                           onClick={() => self.removeEntry(entry.holiday_worked_id)}></i>
                                                    )}
                                                </Badge>
                                            );
                                        })}
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>

                <Modal isOpen={this.state.showModal} toggle={this.toggleModal} size="md">
                    <ModalHeader toggle={this.toggleModal}>
                        {this.state.selectedHoliday ? this.state.selectedHoliday.name : "Add Entry"}
                    </ModalHeader>
                    <ModalBody className="card card-default">
                        <Form>
                            <FormGroup>
                                <Label>Drivers Who Worked</Label>
                                <Select
                                    name="driver_ids"
                                    options={driverOptions}
                                    value={driverOptions.filter((o) => this.state.driver_ids.indexOf(o.value) !== -1)}
                                    onChange={this.onDriversSelect}
                                    placeholder="Select drivers..."
                                    isMulti
                                    isClearable
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Notes</Label>
                                <Input type="textarea" name="notes" value={this.state.notes} onChange={this.updateField} rows="3" />
                            </FormGroup>
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.submitEntry}>
                            <i className={(this.state.processing ? "fa fa-spinner fa-spin mr-2" : "d-none")}></i>
                            Save
                        </Button>
                    </ModalFooter>
                </Modal>

            </ContentWrapper>
        );
    }
}

export default HolidaysWorked;
